import { useTheme } from '../../core'
import { iconFactory } from '../iconFactory'

export interface SearchConditionProps {
  fill?: string
  indicator?: boolean
}

export const SearchCondition = iconFactory(
  'SearchCondition',
  ({ indicator = false, fill }: SearchConditionProps) => {
    const theme = useTheme()

    return (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.1769 10.7V7H10.8231V10.7H7V12.3H10.8231V16H12.1769V12.3H16V10.7H12.1769Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 11.5C3 6.808 6.808 3 11.5 3C16.192 3 20 6.808 20 11.5C20 13.5125 19.2995 15.3623 18.1291 16.8188L22 20.6301L20.7025 22L16.7925 18.1502C15.34 19.3079 13.5004 20 11.5 20C6.808 20 3 16.192 3 11.5ZM4.7 11.5C4.7 15.257 7.743 18.3 11.5 18.3C15.257 18.3 18.3 15.257 18.3 11.5C18.3 7.743 15.257 4.7 11.5 4.7C7.743 4.7 4.7 7.743 4.7 11.5Z"
          fill={fill}
        />

        {indicator && (
          <ellipse
            cx="19.3823"
            cy="4"
            rx="4.36036"
            ry="4"
            fill={theme.colors.red['01']}
          />
        )}
      </>
    )
  },
)
